import { Component, OnInit, Input } from '@angular/core';
import { IMedicationRequest, IPatient, IReference } from '@ahryman40k/ts-fhir-types/lib/R4';
import { ModalController } from '@ionic/angular';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'inc-medication-request-add',
  templateUrl: './medication-request-add.component.html',
  styleUrls: ['./medication-request-add.component.scss'],
})
export class MedicationRequestAddComponent extends AbstractAddComponent<IMedicationRequest> implements OnInit {
  @Input() careplans: IReference[];
  @Input() patient: IPatient;
  @Input() user: any;
  @Input() isModal: boolean;

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    this.form.controls.subject.setValue({ display: this.patient.name[0].text, reference: this.patient.id });
    if (this.user) {
      this.form.controls.recorder.setValue({ display: this.user.displayName, reference: this.user.uid });
      if (this.inData) {
        this.form.patchValue(this.inData);
      }
    }
  }

  close(data?: IMedicationRequest) {
    if (data) {
      data.dispenseRequest.validityPeriod.start = new Date(data.dispenseRequest.validityPeriod.start).toISOString();
      data.dispenseRequest.validityPeriod.end = new Date(data.dispenseRequest.validityPeriod.end).toISOString();
    }
    if (this.isModal) {
      data ? this.modalController.dismiss(data) : this.modalController.dismiss();
    } else {
      this.save(data);
    }
  }

  onSelect(event) {
    if (event && event.value) {
      const careplan = this.careplans.filter(value => value.display === event.value);
      if (careplan && careplan[0]) {
        this.form.controls.basedOn.setValue([careplan[0]]);
      }
    }
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      authoredOn: new FormControl(new Date().toISOString()),
      status: new FormControl('active'),
      intent: new FormControl('order'),
      medicationReference: new FormGroup({
        display: new FormControl('')
      }),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      dosageInstruction: new FormArray([new FormGroup({
        text: new FormControl()
      })]),
      basedOn: new FormArray([
        new FormGroup({
          reference: new FormControl(''),
          display: new FormControl('')
        })
      ]),
      recorder: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      dispenseRequest: new FormGroup({
        validityPeriod: new FormGroup({
          start: new FormControl(new Date().toISOString()),
          end: new FormControl(new Date().toISOString())
        })
      })
    });
  }
}
